import React from "react";
import styled from 'styled-components';
import { enumEstadoTurno } from '../../../utils/constants/estadoTurno.constants';
import { ThemeProvider } from 'styled-components';
    
const Span = styled.span`
    font-size: ${props  => props.theme.fontSize};
    @media print {
        color: green !important;
    }
`;

const BadgeEstadoTurno = ({ estadoID, size = "md", className = "", ...resto }) => {

    const getFontSizes = size => {
        switch (size) {
            case 'xs': return '10px';
            case 'sm': return '12px';
            case 'md': return '14px';
            case 'lg': return '16px';
            case 'xl': return '18px';
            default: return '14px';
        }
    }
    
    const getColor = estadoID => {
        switch (estadoID) {
            case enumEstadoTurno.ACTIVO.id: return 'bg-success';
            case enumEstadoTurno.ASISTIO.id: return 'bg-info';
            case enumEstadoTurno.NO_ASISTIO.id: return 'bg-warning';
            case enumEstadoTurno.ANULADO.id: return 'bg-danger';
            default: return '';
        }
    }
    
    const getText = estadoID => {
        switch (estadoID) {
            case enumEstadoTurno.ACTIVO.id: return enumEstadoTurno.ACTIVO.descripcion;
            case enumEstadoTurno.ASISTIO.id: return enumEstadoTurno.ASISTIO.descripcion;
            case enumEstadoTurno.NO_ASISTIO.id: return enumEstadoTurno.NO_ASISTIO.descripcion;
            case enumEstadoTurno.ANULADO.id: return enumEstadoTurno.ANULADO.descripcion;
            default: return '';
        }
    }


    return (
        <ThemeProvider theme={{ fontSize: getFontSizes(size)}}>

            <Span 
                className={"align-self-centere badge rounded-pill " + getColor(estadoID) + " " + className} 
                {...resto}
            >
                { getText(estadoID) }
            </Span>

        </ThemeProvider>
    )
}

export default BadgeEstadoTurno;